import jQuery from 'jquery'

/**
 * Import jQuery
 * @type {global $}
 */
global.$ = global.jQuery = jQuery



// WEBPACK FOOTER //
// ./src/bootstrap.js